module.exports = __webpack_public_path__ + "static/media/iconConvenios.0f008838.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/servicios/iconConvenios.svg
// module id = 171
// module chunks = 0